import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import "./styles/index.css";
import "./styles/bootstrap.css";
import "./styles/tailwind.css";
import "./styles/custom.css";
import { configureStore, history } from "./store";
import { Provider } from "react-redux";
import { ConnectedRouter } from "connected-react-router";
import "./i18n";

// @ts-ignore
import TimeAgo from "javascript-time-ago";

// @ts-ignore
import fr from "javascript-time-ago/locale/fr";

// form builder
import "./styles/form-builder.css";
// swiper css style
import "swiper/swiper.min.css";
import "swiper/components/navigation/navigation.min.css";

TimeAgo.addDefaultLocale(fr);

const store = configureStore();

// wrap in a render method to support hot module reloading
const render = (Component: any) => {
  return ReactDOM.render(
    <Provider store={store}>
      <ConnectedRouter history={history}>
        <Component />
      </ConnectedRouter>
    </Provider>,
    document.getElementById("root")
  );
};

render(App);

if ((module as any).hot) {
  (module as any).hot.accept("./App", () => {
    const NextApp = require("./App").default;
    render(NextApp);
  });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
